export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Installation\",\n    \"label_other\": \"{{count}} installations\"\n}\n"